__turbopack_context__.v({
  "chevron": "SortFilter-module-scss-module__hsg3Fa__chevron",
  "currentValue": "SortFilter-module-scss-module__hsg3Fa__currentValue",
  "expanded": "SortFilter-module-scss-module__hsg3Fa__expanded",
  "header": "SortFilter-module-scss-module__hsg3Fa__header",
  "label": "SortFilter-module-scss-module__hsg3Fa__label",
  "name": "SortFilter-module-scss-module__hsg3Fa__name",
  "option": "SortFilter-module-scss-module__hsg3Fa__option",
  "options": "SortFilter-module-scss-module__hsg3Fa__options",
  "radio": "SortFilter-module-scss-module__hsg3Fa__radio",
  "sortFilter": "SortFilter-module-scss-module__hsg3Fa__sortFilter",
});
